<template>
    <v-card tile>
            <v-card-title>ข้อมูลตั้งเบิกเลขที่: {{withdrawData.withdrawNo}}</v-card-title>
            <v-divider></v-divider>
    
    <v-container> 
     {{selected_count}}
        <v-btn class="ma-2" color="red" dark @click="closeJobClick" small>จบงาน(ได้รับเงิน)
        <v-icon dark right >payment</v-icon>
      </v-btn>
       <v-btn class="ma-2" dark @click="cancelJobClick" small>ยกเลิกการตั้งเบิก
        <v-icon dark right >cancel</v-icon>
      </v-btn>
      <b> ยอดสุทธิ :</b> {{sum_invoice_amount}} <b> ยอดเบิก : </b>  {{sum_grandWd_Total}} <b> ยอดจ่ายจริง : </b> {{sum_actual_Receipts}}
                <v-dialog v-model="confirmDialog" width="300">
                    <!-- <DialogComfirmCloseJob @closeConfirmDialog="closeConfirm" ></DialogComfirmCloseJob>  -->
                    <template>
                    <div >
                        <v-card>
                            <v-card-title style="background-color: rgb(21, 101, 192); color: white;">
                            ยืนยันการจบงาน
                            </v-card-title>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-card-text>
                            <br />
                            <h3>กรุณากรอก cheque No. : <v-text-field label="cheque No. " :rules="[rules.required]" placeholder=" " maxlength="20" v-model="withdrawData.cheqNo" outlined></v-text-field></h3>
                            
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                @click="hasConfirm"
                            >
                                OK
                            </v-btn>
                            <v-btn
                                color="primary"
                                @click="confirmDialog = false"
                            >
                                CANCEL
                            </v-btn>
                            </v-card-actions>
                        </v-form>    
                        </v-card>
                    </div>
                    </template>
                </v-dialog>

                <v-dialog v-model="closeJobDialog" width="500">
                    <DialogCloseJob ref="closeJob" @clickCloseJob="closeCloseJob"></DialogCloseJob> 
                </v-dialog>

        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            item-key="invoiceNo"
            show-select
            class="elevation-1"
            >

            <template v-slot:item.actualReceipts="{ item }">
            <v-text-field
            v-model="item.actualReceipts"
            :rules="[rules.requiredNumber]"
            type="number"
            style="margin-top:10px;height:65px;"
            outlined>

            </v-text-field>
            </template>

             <template v-slot:item.percentWithdraw="{ item }">
            <v-text-field
            v-model="item.percentWithdraw"
            :rules="[rules.requiredNumber]"
            type="number"
            style="margin-top:10px;height:65px;"
            @blur="calculate(item)"
            outlined>

            </v-text-field>
            </template>

            <template v-slot:item.remark="{ item }">
            <v-text-field
            v-model="item.remark"
            :maxlength ="200"
            style="margin-top:10px; height:65px;"
            outlined>
            </v-text-field>
            </template>

        </v-data-table>

         <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="close"
          >
            CLOSE
          </v-btn>
        </v-card-actions>

    </v-container>
    </v-card>
</template>

<script>
let trnActualReceipts= 0.00;
import {removeItemWithdraw,closeJob} from '@/api/accounting/withdraw-api.js'
import rules from '@/assets/js/rules.js'
import DialogCloseJob from './DialogCloseJob'
import numeral from 'numeral'
export default {
    name: 'editWithdraw',
    components: {
        DialogCloseJob
    },
    computed: {
       selected_count() {
            return this.selected.length + " รายการ / " + this.items.length +" รายการ";
      },
      sum_invoice_amount() {

            let i=0;
            let summary = 0;
            while(i < this.selected.length){
                summary += this.selected[i].invoiceAmount;
                i++;
            }

            return numeral(summary).format('0,0.00');
      },
      sum_grandWd_Total() {
        let i=0;
            let summary = 0;
            while(i < this.selected.length){
                summary += this.selected[i].grandWdTotal;
                i++;
            }
            return numeral(summary).format('0,0.00');
      },
      sum_actual_Receipts() {
        let i=0;
            let summary = 0.00;
            while(i < this.selected.length){
                console.log(this.selected[i].actualReceipts);
                summary += parseFloat(this.selected[i].actualReceipts);
                i++;
            }
            trnActualReceipts = summary;
            return numeral(summary).format('0,0.00');
      }
    },
    props: ["withdrawData"],
    data: () => ({
        rules: rules,
        confirmDialog: false,
        closeJobDialog: false,
        valid: false,
        selected: [],
        headers: [
            {text: "วันที่ใบแจ้งหนี้", value: "strInvoiceDate",width: "130px"},
            {text: "ทะเบียน", value: "licenseNo"},
            {text: "เลขที่ใบสั่งซ่อม", value: "jobNo",width: "140px"},
            {text: "เลขที่ใบประเมิน", value: "estimateNo" ,width: "140px"},
            {text: "เลขที่ใบแจ้งหนี้", value: "invoiceNo",width: "140px"},
            {text: "ยอดสุทธิ", value: "invoiceAmountDisplay",width: "100px"},
            {text: "ยอดเบิก", value: "grandWdTotalDisplay",width: "100px"},
            {text: "จ่ายจริง", value: "actualReceipts",width: "130px"},
            {text: "% เบิก", value: "percentWithdraw",width: "130px"},
            {text: "หมายเหตุ", value: "remark",width: "125px"}
        ],
        items: []
    }),
    methods: {
        
        closeJobClick() {
        
            if(this.selected.length == 0) {
            alert("please select item!!"); 
            return;
            }

            var result = confirm("ต้องการยืนยันการจบงานใช่หรือไม่?");
            if(!result){ return; }

            this.confirmDialog = true;   
        },
        cancelJobClick() {
                           
            if(this.selected.length == 0) {
            alert("please select item!!"); 
            return;
            }

            var result = confirm("ต้องการยกเลิกการตั้งเบิกใช่หรือไม่?");
            if(!result){ return; }
            this.withdrawData.listData = this.selected;
            //call api cancel
            removeItemWithdraw(this.withdrawData).then(() => {
                this.$loading(false);
                this.close();
            }).catch(()=> {
                this.$loading(false);
            });    
            
        },
        setItems(items){
            this.items = Object.assign([], items);
             if (this.items) {
                this.items.forEach((e) => {
                    e.invoiceAmountDisplay = numeral(e.invoiceAmount).format('0,0.00');
                    e.grandWdTotalDisplay = numeral(e.grandWdTotal).format('0,0.00');
                    e.grandWdTotal = Math.round(e.grandWdTotal*100)/100;
                    e.actualReceipts = Math.round(e.grandWdTotal*100)/100;    //*100/100 เพื่อปัดทศนิยม 2 หลักให้ถูกต้อง            
                });
             }
        },
        hasConfirm(){
            if (!this.$refs.form.validate()) {
                return;
            }
            //withdrawData.withdrawNo = this.withdrawNo;
            this.withdrawData.listData = this.selected;
            // call api close job  
            closeJob(this.withdrawData).then(response => {
                this.$loading(false);
                //this.withdrawData = response;
                this.confirmDialog = false; 
                this.closeJobDialog = true;
                 this.$nextTick(() => {
                    
                    this.$refs.closeJob.setData(response,trnActualReceipts);
                })
            }).catch(()=> {
                this.$loading(false);
            });    
              
        },
        closeCloseJob() {
            this.closeJobDialog = false;
            this.close();
        },
        close() {
            this.$emit("closeDialog");
            this.selected = [];
        },
        calculate(item){
          item.grandWdTotal =  Math.round(item.invoiceAmount * (item.percentWithdraw/100)*100)/100;
          item.grandWdTotalDisplay =  numeral(item.grandWdTotal).format('0,0.00');
          item.actualReceipts =  Math.round(item.grandWdTotal*100)/100; 
        }
    }
   
}
</script>